import { createReducer, on } from "@ngrx/store";
import { ReducerUtilsService } from "../../../services/reducer-utils.service";
import { VigilantApiDtoRealm } from "./realms.model";
import * as RealmsActions from "./realms.actions";
export { RealmsActions };

export interface RealmsState {
  realms: VigilantApiDtoRealm[] | undefined;
}

const defaultState: RealmsState = {
  realms: undefined,
};

export const realmsReducer = createReducer(
  defaultState,

  on(
    RealmsActions.SetRealms,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.set(action.realms),
    })
  ),

  on(
    RealmsActions.ResetRealms,
    (state): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.reset(),
    })
  ),

  on(
    RealmsActions.AddRealm,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.addItem(state.realms, action.realm),
    })
  ),

  on(
    RealmsActions.AddRealms,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.addItems(state.realms, action.realms),
    })
  ),

  on(
    RealmsActions.UpdateRealm,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.updateItem(state.realms, action.realm),
    })
  ),


  on(
    RealmsActions.UpdateRealms,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.updateItems(state.realms, action.realms),
    })
  ),

  on(
    RealmsActions.DeleteRealm,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.deleteItem(state.realms, action.id),
    })
  ),
  on(
    RealmsActions.DeleteRealms,
    (state, action): RealmsState => ({
      ...state,
      realms: ReducerUtilsService.deleteItems(state.realms, action.ids),
    })
  )
);
